import type { FC } from "react";

import { useSERPData } from "../hooks/useSERPData";
import { SerpComposition } from "../serp-composition/SerpComposition";
import { SerpMetrics } from "../serp-metrics/SerpMetrics";

export const SerpContainer: FC = () => {
    const { serpCompositionData, serpMetricData, isLoading, aiExistence } = useSERPData();

    return (
        <>
            <SerpComposition
                isLoading={isLoading}
                graphItems={serpCompositionData}
                aiExistence={aiExistence}
            />
            <SerpMetrics
                isLoading={isLoading}
                metricItems={serpMetricData}
            />
        </>
    );
};
